import { 
  preLoadResumeData,
  checkIfEducationItemExists, 
  checkIfWorkExperienceItemExists,
  checkIfRegistrationItemExists,
  checkIfTrainingItemExists,
  checkIfLanguageItemExists,
} from './utils/navigation-guards';

export default [
    {
      name: 'cv-view',
      path: '/cv',
      component: () => import('@web/pages/cv/CVOverview.vue'),
      meta: { title: 'CV' },
      children: [
        {
          name: 'cv',
          path: '',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/Index.vue'),
          },
          meta: { 
            title: 'CV',
            showContent: true
          },
        },
        {
          name: 'work-experience add',
          path: '/cv/work-experience/add',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/work/AddWorkExperience.vue'),
          },
          meta: { title: 'CV - Werkervaring Toevoegen' },
        },
        {
          name: 'work-experience edit',
          path: '/cv/work-experience/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/work/EditWorkExperience.vue'),
          },
          meta: { title: 'CV - Werkervaring Wijzigen' },
          beforeEnter: [preLoadResumeData, checkIfWorkExperienceItemExists],
        },
        {
          name: 'education add',
          path: '/cv/education/add',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/education/AddEducation.vue'),
          },
          meta: { title: 'CV - Opleiding Toevoegen' },
        },
        {
          name: 'education edit',
          path: '/cv/education/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/education/EditEducation.vue'),
          },
          meta: { title: 'CV - Opleiding Wijzigen' },
          beforeEnter: [preLoadResumeData, checkIfEducationItemExists],
        },
        {
          name: 'competencies edit',
          path: '/cv/competencies/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/competencies/EditCompetencies.vue'),
          },
          meta: { title: 'CV - Handelingen wijzigen' },
        },
        {
          name: 'languages add',
          path: '/cv/languages/add',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/languages/AddLanguage.vue'),
          },
          meta: { title: 'CV - Taalvaardigheid Toevoegen' },
        },
        {
          name: 'cv languages edit',
          path: '/cv/languages/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/languages/EditLanguage.vue'),
          },
          meta: { title: 'CV - Taalvaardigheid Wijzigen' },
          beforeEnter: [preLoadResumeData, checkIfLanguageItemExists],
        },
        {
          name: 'registration add',
          path: '/cv/registration/add',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/registrations/AddRegistration.vue'),
          },
          meta: { title: 'CV - Registratie Toevoegen' },
        },
        {
          name: 'registration edit',
          path: '/cv/registration/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/registrations/EditRegistration.vue'),
          },
          meta: { title: 'CV - Registratie Wijzigen' },
          beforeEnter: [preLoadResumeData, checkIfRegistrationItemExists],
        },
        {
          name: 'training add',
          path: '/cv/training/add',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/training/AddTraining.vue'),
          },
          meta: { title: 'CV - Aanvullende Scholing Toevoegen' },
        },
        {
          name: 'training edit',
          path: '/cv/training/edit/:id',
          components: {
            detailColumn: () => import('@web/pages/cv/detail-column/training/EditTraining.vue'),
          },
          meta: { title: 'CV - Aanvullende Scholing Bewerken' },
          beforeEnter: [preLoadResumeData, checkIfTrainingItemExists],
        },
      ],
    },
];
